import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import { Toaster } from "sonner";
import { App } from "./App";
import { ApiError } from "./lib/api";
import { TooltipProvider } from "./components/overlay";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      // don't retry client errors (401, 404, validation)
      retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 2,
    },
  },
});

// A data router (rather than <BrowserRouter>) so screens can use useBlocker
// for unsaved-changes guards. App keeps its own <Routes> beneath one catch-all.
const router = createBrowserRouter([
  {
    path: "*",
    element: (
      <TooltipProvider>
        <App />
      </TooltipProvider>
    ),
  },
]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster
        position="bottom-right"
        toastOptions={{
          classNames: {
            toast: "!rounded-xl !border-line-soft !bg-paper !text-ink !shadow-[var(--shadow-pop)] !font-sans",
            description: "!text-muted",
          },
        }}
      />
    </QueryClientProvider>
  </StrictMode>,
);
